import React from 'react'
import classes from './siteButton.module.css'

const SiteButton = ({children, ...props}) => {
    return (
        <button {...props} className={classes.siteBtn}>
            {children}
        </button>
    )
}

export default SiteButton;